import { Circle, View, XStack, type XStackProps } from "tamagui";
import type { IconProp } from "./icons";
import { Label } from "./Label";

export type DotProps = {
  completed: boolean;
  step?: number;
  percent?: number;
  icon?: IconProp;
  onPress?: () => void;
};

type DotWizardProps = XStackProps & { dots: DotProps[] };

export const DotWizard = ({ dots, ...viewProps }: DotWizardProps) => {
  const content = [];

  for (let i = 0; i < dots.length; i++) {
    const nextDot = dots[i + 1];
    const currentDot = dots[i];

    const Icon = currentDot.icon;

    const isActive = currentDot.completed;

    content.push(
      <Circle
        key={i}
        onPress={currentDot.onPress}
        size={"$medium"}
        backgroundColor={isActive ? "$primary" : "$divider"}
      >
        {Icon && <Icon size={20} />}
        {currentDot.step && <Label>{currentDot.step}</Label>}
      </Circle>,
    );

    if (nextDot) {
      content.push(
        <View
          key={`${i}_div`}
          height={10}
          backgroundColor={nextDot.completed ? "$primary" : "$divider"}
          onPress={currentDot.onPress}
          flex={1}
        >
          {currentDot.percent !== undefined && currentDot.percent > 0 && (
            <View
              key={`${i}_div_filled`}
              height={10}
              backgroundColor={"$primary"}
              borderEndEndRadius={5}
              borderStartEndRadius={5}
              borderColor={"$primary"}
              borderWidth={1}
              width={`${Math.min(currentDot.percent * 100, 100)}%`}
              flex={1}
            />
          )}
        </View>,
      );
    }
  }

  return (
    <XStack {...viewProps} alignItems="center">
      {content}
    </XStack>
  );
};
